import { CAROUSEL_CHANGED } from '../redux/tracking';
import get from 'lodash/get';

import type {
  CarouselChangedTracker,
  CarouselChanged,
  EventTracking,
  Store,
} from '../types';

function carouselChanged(
  action: CarouselChanged,
  state: Store,
): CarouselChangedTracker {
  return {
    direction: get(action, 'payload.direction'),
    index: get(action, 'payload.index') + 1,
  };
}

// Make sure you cast this before you export it in your duckling.

const tracking: EventTracking = {};
tracking[CAROUSEL_CHANGED] = carouselChanged;

export default tracking;
